
import DirectDown from "../../../assets/duotone/DirectDown.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DirectDownIcon({ className, dataTestid = "DirectDownIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DirectDown data-testid={dataTestid} className={classes} {...rest} />
  );
}
